<template>
  <OrderPage />
</template>

<script>
import OrderPage from '@/components/OrderPage.vue';

export default {
  name: 'OrderPageView',
  components: {
    OrderPage,
  },
};
</script>